<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Deployment</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li> Our Deployment</li>
                </ul>
            </div>
        </div> 
    </div>
</section>


<!-- DEPLOYMENT SECTION -->
<section id="deployment" class="parallax-section">
	<div class="container">
		<div class="text-center wow fadeInUp">
			<h2 class="content-title">Our Deployment</h2>
		</div>
		<div class="row">
			<div class="middleEast wow fadeInUp col-md-6 mt-5">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Middle East</h3>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Qatar.png" alt="">
						<p>Qatar</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Kuwait.png" alt="">
						<p>Kuwait</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Oman.png" alt="">
						<p>Oman</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Bahrain.png" alt="">
						<p>Bahrain</p>
					</div>
					<div class="offset-md-3 col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-United-Arab-Emirates.png" alt="">
						<p>UAE</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/saudi-flag.jpg" alt="">
						<p>Saudi</p>
					</div>
				</div>
			</div>
			<div class="asia wow fadeInUp col-md-6 mt-5">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>ASIA</h3>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Korea-South.png" alt="">
						<p>South Korea</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Japan.png" alt="">
						<p>Japan</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-hongkong.png" alt="">
						<p>Hong Kong</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-China.png" alt="">
						<p>China</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Singapore.png" alt="">
						<p>Singapore</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Brunei.png" alt="">
						<p>Brunei</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Malaysia.png" alt="">
						<p>Malaysia</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Vietnam.png" alt="">
						<p>Vietnam</p>
					</div>
					<div class="offset-md-1 col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Thailand.png" alt="">
						<p>Thailand</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Taiwan.png" alt="">
						<p>Taiwan</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Cambodia.png" alt="">
						<p>Cambodia</p>
					</div>
				</div>
			</div>
			<div class="northAmerica wow fadeInUp col-md-6">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Western Countries</h3>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Belgium.png" alt="">
						<p>Belgium</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Canada.png" alt="">
						<p>Canada</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-flag-of-United-Kingdom.png" alt="">
						<p>United Kingdom</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Austria.png" alt="">
						<p>Austria</p>
					</div>
				</div>
			</div>
			<div class="europe wow fadeInUp col-md-6">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Central Countries</h3>
					</div>
					<div class="offset-md-2 col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Croatia.png" alt="">
						<p>Croatia</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Poland.png" alt="">
						<p>Poland</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Germany.png" alt="">
						<p>Germany</p>
					</div>
				</div>
			</div>
			<div class="africa wow fadeInUp col-md-8 offset-md-2">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Africa</h3>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Tanzania.png" alt="">
						<p>Tanzania</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Nigeria.png" alt="">
						<p>Nigeria</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Ghana.png" alt="">
						<p>Ghana</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-South-Sudan.png" alt="">
						<p>South Sudan</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Angola.png" alt="">
						<p>Angola</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Ethiopia.png" alt="">
						<p>Ethiopia</p>
					</div>
					<div class="offset-md-2 col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Mozambique.png" alt="">
						<p>Mozambique</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Libya.png" alt="">
						<p>Libya</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Cote-d-Ivoire.png" alt="">
						<p>Cote d'lvoire</p>
					</div>
					<div class="col-md-2 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-South-Africa.png" alt="">
						<p>South Africa</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>



















<!-- <section id="deployment" class="parallax-section">
	<div class="container">
		<div class="text-center wow fadeInUp">
			<h2 class="content-title">Our Deployment</h2>
		</div>
		<div class="row">
			<div class="middleEast wow fadeInUp col-md-6 mt-5">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Middle East</h3>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Qatar.png" alt="">
						<p>Qatar</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Kuwait.png" alt="">
						<p>Kuwait</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Oman.png" alt="">
						<p>Oman</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Bahrain.png" alt="">
						<p>Bahrain</p>
					</div>
					<div class="offset-md-4 col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-United-Arab-Emirates.png" alt="">
						<p>UAE</p>
					</div>
				</div>
			</div>
			<div class="asia wow fadeInUp col-md-6 mt-5">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>ASIA</h3>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Korea-South.png" alt="">
						<p>South Korea</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Japan.png" alt="">
						<p>Japan</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-hongkong.png" alt="">
						<p>Hong Kong</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-China.png" alt="">
						<p>China</p>
					</div>
					<div class="offset-md-1 col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Singapore.png" alt="">
						<p>Singapore</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Brunei.png" alt="">
						<p>Brunei</p>
					</div>
					<div class="col-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Malaysia.png" alt="">
						<p>Malaysia</p>
					</div>
				</div>
			</div>
			<div class="northAmerica wow fadeInUp col-md-4">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>North America</h3>
					</div>
					<div class="col-md-6 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-United-States-of-America.png" alt="">
						<p>USA</p>
					</div>
					<div class="col-md-6 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Canada.png" alt="">
						<p>Canada</p>
					</div>
				</div>
			</div>
			<div class="europe wow fadeInUp col-md-4">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Europe</h3>
					</div>
					<div class="col-md-6 offset-md-3 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-United-Kingdom.png" alt="">
						<p>United Kingdom</p>
					</div>
				</div>
			</div>
			<div class="africa wow fadeInUp col-md-4">
				<div class="row">
					<div class="col-md-12 text-center">
						<h3>Africa</h3>
					</div>
					<div class="col-md-6 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-Madagascar.png" alt="">
						<p>Madagascar</p>
					</div>
					<div class="col-md-6 p-3 text-center">
						<img class="img-fluid" src="/assets/images/country/flag-of-South-Africa.png" alt="">
						<p>South Africa</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->